module.exports = __webpack_public_path__ + "static/media/03-kor.94cae2da.png";